export default __webpack_public_path__ + "9047b7637a52b8366853f13107cfd38c.png";